export default __webpack_public_path__ + "static/media/check-circle.f96c1fb3.svg";